/**
 * Represents an empty frozen array.that can be used as a default and checked for
 * @type {number[]}
 */
export const emptyArray = Object.freeze([])
